function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineComponent, onBeforeUnmount, onMounted, reactive, computed, watch, h } from '@vue/composition-api';
import { withInstall, raf, doubleRaf, useExpose } from '../util/index';
import Config from '../config';
import "../style/components/marquee.css";
var Marquee = defineComponent({
  name: 'm-marquee',
  props: {
    text: {
      type: [String, Array],
      "default": ''
    },
    delay: {
      type: [String, Number],
      "default": 1000
    },
    speed: {
      type: [String, Number],
      "default": 60
    },
    isRtl: {
      type: Boolean,
      "default": false
    },
    gap: {
      type: [String, Number],
      "default": undefined
    },
    iterationCount: {
      type: [String, Number],
      "default": 'infinite'
    }
  },
  slots: ['default'],
  setup: function setup(props, context) {
    var timer;
    var state = reactive({
      containerWidth: 0,
      ctxWidth: 0,
      duration: 0,
      play: false
    });
    var items = computed(function () {
      return Array.isArray(props.text) ? props.text : [props.text];
    }); // 计算间距

    var gap = computed(function () {
      return isNaN(+props.gap) ? props.gap || "".concat(state.containerWidth, "px") : "".concat(props.gap, "px");
    });
    var isRtl = computed(function () {
      return props.isRtl || Config.getDirection() === 'rtl';
    });

    var reset = function reset() {
      var _context$refs$contain;

      state.containerWidth = (_context$refs$contain = context.refs.container) === null || _context$refs$contain === void 0 ? void 0 : _context$refs$contain.clientWidth;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!props.text || !props.text.length) return;
        raf(function () {
          return doubleRaf(function () {
            var _context$refs$ctx;

            state.ctxWidth = (_context$refs$ctx = context.refs.ctx) === null || _context$refs$ctx === void 0 ? void 0 : _context$refs$ctx.clientWidth;
            if (state.ctxWidth - parseFloat("".concat(gap.value)) <= state.containerWidth) return;
            state.duration = state.ctxWidth / +props.speed;
            state.play = true;
            context.emit('play');
          });
        });
      }, +props.delay);
    };

    var handleAnimationend = function handleAnimationend() {
      context.emit('end');
      state.play = false;
    };

    onMounted(reset);
    watch(function () {
      return props.text;
    }, reset);
    onBeforeUnmount(function () {
      return clearTimeout(timer);
    });
    useExpose({
      reset: reset
    });
    return function () {
      return h("div", {
        "ref": 'container',
        "class": 'm-marquee',
        "style": {
          direction: isRtl.value ? 'rtl' : 'lrt'
        }
      }, [h("div", {
        "ref": 'ctx',
        "class": ['m-marquee_ctx', state.play ? "m-marquee_ctx_".concat(isRtl.value ? 'right' : 'left') : ''],
        "style": {
          animationIterationCount: props.iterationCount,
          animationDuration: "".concat(state.duration, "s")
        },
        "on": {
          "animationiteration": function animationiteration() {
            return context.emit('replay');
          },
          "animationend": handleAnimationend
        }
      }, [items.value.map(function (val, index) {
        return h("span", {
          "class": 'm-marquee_text',
          "style": "".concat(isRtl.value ? 'marginLeft' : 'marginRight', ":").concat(gap.value)
        }, [context.slots["default"] ? context.slots["default"]({
          item: val,
          index: index
        }) : val]);
      }), state.play && h("span", {
        "class": 'm-marquee_text',
        "style": _defineProperty({
          position: 'absolute'
        }, isRtl.value ? 'right' : 'left', '100%')
      }, [context.slots["default"] ? context.slots["default"]({
        item: items.value[0],
        index: 0
      }) : items.value[0]])])]);
    };
  }
});
withInstall(Marquee);
export default Marquee;